import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-bg">
        <img src="https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=1920&q=80" alt="面道" />
        <div className="footer-overlay"></div>
      </div>
      <div className="footer-container">
        <div className="footer-brand">
          <div className="footer-logo-img">
            <img src="https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=200&q=80" alt="面道Logo" />
          </div>
          <div className="footer-logo">
            <span>面</span>
            <span>道</span>
          </div>
          <p>一碗好面 · 匠心传承</p>
        </div>
        <div className="footer-links">
          <div className="footer-col">
            <h4>快速链接</h4>
            <a href="#menu" onClick={(e) => scrollToSection(e, '#menu')}>菜单</a>
            <a href="#gallery" onClick={(e) => scrollToSection(e, '#gallery')}>工艺</a>
            <a href="#about" onClick={(e) => scrollToSection(e, '#about')}>品牌</a>
          </div>
          <div className="footer-col">
            <h4>营业时间</h4>
            <p>周一至周日</p>
            <p>10:00 - 22:00</p>
          </div>
          <div className="footer-col">
            <h4>联系我们</h4>
            <p>北京市朝阳区</p>
            <p>建国路88号</p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 面道 · 匠心面馆 版权所有</p>
      </div>
    </footer>
  );
};

export default Footer;
